import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {ApplicationPropertyRS} from '../../../admin/service/applicationPropertyRS.rest';
import {TSRole} from '../../../models/enums/TSRole';
import TSUser from '../../../models/TSUser';
import TSAuthLoginElement from '../../model/TSAuthLoginElement';
import AuthServiceRS from '../../service/AuthServiceRS.rest';
import AuthenticationUtil from '../../utils/AuthenticationUtil';
import IRootScopeService = angular.IRootScopeService;
import ITimeoutService = angular.ITimeoutService;
let template = require('./dummyAuthentication.html');
require('./dummyAuthentication.scss');

export class DummyAuthenticationComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = DummyAuthenticationListViewController;
    controllerAs = 'vm';
}

export class DummyAuthenticationListViewController {

    public usersList: Array<TSUser>;
    public superadmin: TSUser;
    private devMode: boolean;

    static $inject: string[] = ['$state', 'AuthServiceRS', '$timeout', 'ApplicationPropertyRS', '$rootScope'];

    constructor(private $state: IStateService, private authServiceRS: AuthServiceRS,
                private $timeout: ITimeoutService, private applicationPropertyRS: ApplicationPropertyRS,
                private $rootScope: IRootScopeService) {
        this.usersList = [];
        applicationPropertyRS.isDevMode().then((response) => {
            this.devMode = response;
        });

        this.usersList.push(new TSUser('Markus', 'Hofstetter', 'password10', 'markus.hofstetter@mailbucket.dvbern.ch', [TSRole.SUPER_ADMIN]));
        this.usersList.push(new TSUser('Pascal', 'Gatschet', 'password10', 'pascal.gatschet@mailbucket.dvbern.ch', [TSRole.SUPER_ADMIN]));
        this.usersList.push(new TSUser('Fritz', 'Fondssuissse', 'password10', 'fritz.fondssuissse@mailbucket.dvbern.ch', [TSRole.FONDSSUISSE_ADMIN]));
        this.usersList.push(new TSUser('Frieda', 'Fondssuissse', 'password10', 'frieda.fondssuissse@mailbucket.dvbern.ch', [TSRole.FONDSSUISSE_SACHBEARBEITER]));
        this.usersList.push(new TSUser('Veronique', 'Verwalter', 'password10', 'veronique.verwalter@mailbucket.dvbern.ch', [TSRole.ANLAUFSTELLE_VERWALTER]));
        this.usersList.push(new TSUser('Anton', 'Anlaufstelle', 'password10', 'anton.anlaufstelle@mailbucket.dvbern.ch', [TSRole.ANLAUFSTELLE_SACHBEARBEITER]));
        this.usersList.push(new TSUser('Sarah', 'Schaetzer', 'password10', 'sarah.schaetzer@mailbucket.dvbern.ch', [TSRole.ANLAUFSTELLE_SCHAETZER]));
        this.usersList.push(new TSUser('Karl', 'Kantonsverwalter', 'password10', 'karl.kanton@mailbucket.dvbern.ch', [TSRole.KANTON_VERWALTER]));
        this.usersList.push(new TSUser('Kunigunde', 'Kantonsinspektor', 'password10', 'kunigunde.kantoninspektor@mailbucket.dvbern.ch', [TSRole.KANTON_INSPEKTOR]));
        this.usersList.push(new TSUser('Gottfried', 'Gesuchsteller', 'password10', 'gottfried.gesuchsteller@mailbucket.dvbern.ch', [TSRole.BETROFFENER]));
        this.usersList.push(new TSUser('Gabi', 'Gesuchsteller', 'password10', 'gabi.gesuchsteller@mailbucket.dvbern.ch', [TSRole.BETROFFENER]));
        this.superadmin = new TSUser('Serfuser', 'Superuser', 'password10', 'hallo@dvbern.ch', [TSRole.SUPER_ADMIN]);
    }

    /**
     * Die Institution wird direkt gegeben. Diese Daten und die Daten der DB muessen uebereinstimmen
     */
    private getAnlaufstelle(): any {

    }

    public logIn(user?: TSUser): void {
        if (user) {
            let loginCredentials: TSAuthLoginElement = new TSAuthLoginElement();
            loginCredentials.password = user.password;
            loginCredentials.username = user.email;
            this.authServiceRS.loginRequest(loginCredentials).then((response?: TSUser) => {
                if (response && response.roles) {
                    let mostPrivilegedRole = this.authServiceRS.getHighestRoleOfBenutzer(response.roles);
                    AuthenticationUtil.navigateToStartPageForRole(mostPrivilegedRole, this.$state);

                }

            });

        }
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/component/dummy/dummyAuthenticaton.ts